import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import * as registerServiceWorker from "./registerServiceWorker";
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import store from './store/configureStore';

const rootElement = document.getElementById('root');

const history = createBrowserHistory();

ReactDOM.render(
    <Provider store={store}>
        <Router basename="/" history={history}>
            <App />
        </Router>
    </Provider>,
    rootElement
);

registerServiceWorker.register({
    onUpdate: (registration) => {
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        window.location.reload();
    }
});
